import React, { type ComponentProps } from 'react';

import cn from 'classnames';

import BSALogo from '../BSALogo';
import Img from '../Img';
import styles from './AdvancementImage.less';

type ImgProps = ComponentProps<'img'>;

interface AdvancementImageProps extends ImgProps {
  src?: string;
  className?: string;
}

const AdvancementImage = ({
  src,
  className,
  ...props
}: AdvancementImageProps) =>
  src ? (
    <Img src={src} className={cn(styles.image, className)} {...props} />
  ) : (
    <BSALogo className={className} {...props} />
  );

export default AdvancementImage;
